import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import TweenLite from 'gsap/TweenLite';
import TimelineLite from 'gsap/TimelineLite';
import { Container, ticker, Sprite, Texture, Text } from 'pixi.js';
import 'gsap/PixiPlugin';
import 'gsap/ColorPropsPlugin';
import ReactMarkdown from 'react-markdown';

import events from '../../utils-and-data/events.js';
import { GetSimpleRect } from '../../utils-and-data/utils.js';
import FxLayer from '../partials/fx-layer.js';
import BackgroundGhost from '../animations/background';

// @TODO: move these into config, maybe?
const eventOptions = {
  passive: false,
  capture: true
};

class RubAway extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.ghosting = false;
    this.initialised = false;
    this.destroyTimer = null;
    this.AREA_DIVISIONS = 2;
    this.START_GHOST_TOUCH_THRESHOLD = 0;
  }

  componentWillUpdate(nextProps, nextState) {

    // Allow the webGL layer to follow the carousel's movement:
    if (nextProps.ghostTransX
      && this.initialised && this.ghosting) {
      this.container.x = nextProps.ghostTransX;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.order !== this.props.order) {
      this.initOrDestroy();
    } else if (prevProps.dimensions.height !== this.props.dimensions.height) {
      this.hitzoneRect = GetSimpleRect(this.hitzoneRef);
      this.floTextRect = GetSimpleRect(this.floTextRef);
      this.resizeScene();
    }
  }

  resetQuadrants() {
    let arr = [];
    arr.length = (this.AREA_DIVISIONS + 1) * (this.AREA_DIVISIONS + 1);
    arr.fill(0);
    return arr;
  }

  componentDidMount() {
    this.initOrDestroy(this.props);
  }

  componentWillUnmount() {
    this.destroyGhost();
  }

  initOrDestroy() {
    if (this.props.order === 'curr'
      && this.initialised === false) {

      this.initialised = true;
      this.startTimer = setTimeout(() => this.initGhost(), 5);
    } else {
      this.destroyGhost();
    }
  }

  initGhost() {
    console.log('[RubAway] initGhost() for page', this.props.pageNumber);
    this.captureEvents();
    this.props.resetCarousel();
    this.props.setCarouselLock(true);
    this.hitzoneRect = GetSimpleRect(this.hitzoneRef);
    this.floTextRect = GetSimpleRect(this.floTextRef);
    this.editQuadrants = this.resetQuadrants();
    this.createGhostScene();
  }

  destroyGhost() {
    console.log('[RubAway] destroyGhost() for page', this.props.pageNumber);
    clearTimeout(this.startTimer);
    clearTimeout(this.autoRevealTimer);
    this.autoRevealTimer = null;
    events.emit('setLighting', { mode: 'light' });
    this.oldPos = this.finger = null;
    if (!this.initialised) return;
    if (this.bg) this.bg._destroy();
    if (this.container) this.cleanup();
    if (this.ticker) this.ticker.stop();

    this.canvas = null;
    this.maskSprite.texture.destroy();
    this.maskSprite.destroy();
    FxLayer.voiceLayer.clearChildren();
    FxLayer.stop();
    this.canvas = null;
    delete this.canvas;
    this.initialised = false;
    this.ghosting = false;
    this.complete = false;
  }

  cleanup() {
    // loop through all elements appended to scene and remove them
    while (this.container.children[0]) {
      this.container.removeChild(this.container.children[0]);
    }
  }

  createGhostScene() {
    console.log('[RubAway] createGhostScene() for page', this.props.pageNumber);

    FxLayer.start();

    // Setup canvas drawing ticker
    this.ticker = new ticker.Ticker();
    this.ticker.stop();
    this.ticker.add(this.onDrawMove);

    this.container = new Container();
    this.bg = new BackgroundGhost(this.props, 'rubaway');

    // Create a canvas to draw on, and use as a texture mask for pixi:
    // @TODO: Draw in white to have pixi reveal everything
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.props.dimensions.width;
    this.canvas.height = this.props.dimensions.height;
    this.maskCtx = this.canvas.getContext('2d');
    this.maskCtx.beginPath();
    this.maskCtx.rect(0,0,this.props.dimensions.width,this.props.dimensions.height);
    // this.maskCtx.fillStyle = '#fff';
    // this.maskCtx.fillStyle = '#000';
    // this.maskCtx.fill();

    this.maskSprite = new Sprite(PIXI.Texture.fromCanvas(this.canvas));
    this.container.addChild(this.maskSprite);
    this.maskSprite.texture.update();

    let text = this.props.ghost.paragraphs.join(' ');
    let textContainer = new Container();
    let textObj = new Text(text, {
      fill : 0xffffff,
      align : 'center',
      wordWrap: true,
      wordWrapWidth: this.floTextRect.width,
      fontFamily: 'Averia Serif Libre',
      fontWeight: 300,
      fontSize: 16,
      lineHeight: 25
    });
    textObj.position.x = (this.props.dimensions.width / 2) - (textObj.width / 2);
    textObj.position.y = (this.props.dimensions.height / 2) - (textObj.height / 2);
    textContainer.addChild(textObj);
    this.container.addChild(
      this.bg,
      textContainer
    );
    this.container.addChild(this.maskSprite);

    FxLayer.voiceLayer.addChild(this.container);
    this.container.mask = this.maskSprite;

    // @DEBUG: Now draw proper hide mask texture:
    // this.maskCtx.beginPath();
    // this.maskCtx.rect(0,0,this.props.dimensions.width,this.props.dimensions.height);
    // this.maskCtx.fillStyle = '#000';
    // this.maskCtx.fill();
    // this.maskTexture.update();

    // MP: we only show bg here, it gives enought time for
    // everything be constructed
    this.bg.show();

    // Get the edit detection logic ready:
    this.setupGridLines(textObj);

    // Draw in the mask hint:
    this.firstDraw();

    // Ensure the carousel is where it needs to be:
    this.props.resetCarousel();

    console.log(
      'GHOST SCENE CREATED. pixi objs:',
      this.container, this.maskSprite,
    );
  }

  setupGridLines(textObj) {
    console.log('[RubAway] setupGridLines()');
    this.gridLines = { x: [], y: [] };
    let w = textObj.width / (this.AREA_DIVISIONS + 1);
    let h = textObj.height / (this.AREA_DIVISIONS + 1);
    this.gridLines.x.push(textObj.position.x);
    this.gridLines.y.push(textObj.position.y);
    let count = 1;
    while (count <= this.AREA_DIVISIONS) {
      console.log('[RubAway] setupGridLines() creating positions');
      this.gridLines.x.push(textObj.position.x + (w * count));
      this.gridLines.y.push(textObj.position.y + (h * count));
      count++;
    }
    this.gridLines.x.push(textObj.position.x + textObj.width);
    this.gridLines.y.push(textObj.position.y + textObj.height);
    console.log('[RubAway] setupGridLines() finished');
  }

  resizeScene() {
    // @TODO:
    // resize the pixi js scene:
  }

  showGhost() {
    console.log('[RubAway] showGhost()');
    this.ghosting = true;
    this.props.resetCarousel();
  }

  firstDraw() {
    console.log('[RubAway] firstDraw() start');
    this.oldPos = null;
    const { width, height } = this.props.dimensions;
    this.p = { x: width - 100, y: height - 10 };
    this.ticker.start();
    TweenLite.to(this.p, 1.5, {
      x: '+=80',
      y: '-=70',
      onUpdate: () => {
        this.finger = this.p
      },
      onComplete: () => {
        this.ticker.stop();
        console.log('[RubAway] firstDraw() onComplete...', this.finger);
        this.oldPos = this.finger = null;
      }
    });
  }

  unlock() {
    console.log('[RubAway] unlock()');
    FxLayer.bounce(() => {
      this.releaseEvents();
      this.props.setCarouselLock(false);
    });
  }

  // define some custom canvas methods:
  captureEvents() {
    this.hitzoneRef.addEventListener('mousedown', this.onDrawStart, eventOptions);
    this.hitzoneRef.addEventListener('mouseup', this.onDrawEnd, eventOptions);
    this.hitzoneRef.addEventListener('touchstart', this.onDrawStart, eventOptions);
    this.hitzoneRef.addEventListener('touchend', this.onDrawEnd, eventOptions);
  }

  releaseEvents() {
    this.hitzoneRef.removeEventListener('mouseup', this.onDrawEnd, eventOptions);
    this.hitzoneRef.removeEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.removeEventListener('mousedown', this.onDrawStart, eventOptions);

    this.hitzoneRef.removeEventListener('touchend', this.onDrawEnd, eventOptions);
    this.hitzoneRef.removeEventListener('touchmove', this.onTouchMove, eventOptions);
    this.hitzoneRef.removeEventListener('touchstart', this.onDrawStart, eventOptions);
  }

  stopAndPrevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  onDrawStart = (e) => {
    console.log('[RubAway] onDrawStart()');
    if (this.p) TweenLite.killTweensOf(this.p);
    // console.log('draw start!', e);
    this.ticker.start();
    this.oldPos = this.finger = null;
    this.stopAndPrevent(e);

    this.hitzoneRef.addEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.addEventListener('touchmove', this.onTouchMove, eventOptions);
    if (!this.autoRevealTimer) this.autoRevealTimer = setTimeout(() => {
      this.resumeBook()
    }, 5000);
  }

  onDrawEnd = (e) => {
    console.log('[RubAway] onDrawEnd()');
    this.ticker.stop();
    this.stopAndPrevent(e);
    this.oldPos = this.finger = null;
    this.hitzoneRef.removeEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.removeEventListener('touchmove', this.onTouchMove, eventOptions);
  }

  onMouseMove = (e) => {
    console.log('[RubAway] onMouseMove()');
    this.stopAndPrevent(e);
    let y = e.pageY - this.hitzoneRect.top;
    let x = e.pageX - this.hitzoneRect.left;
    this.finger = { x, y };
  }

  onTouchMove = (e) => {
    console.log('[RubAway] onTouchMove()');
    this.stopAndPrevent(e);
    let x = e.touches[0].clientX - this.hitzoneRect.left,
      y = e.touches[0].clientY - this.hitzoneRect.top;
    this.finger = { x, y };
  }


  onDrawMove = () => {
    if (this.complete || !this.finger) return;
    if (!this.oldPos) this.oldPos = { ...this.finger };
    
    // Detect if they've dragged enough from the start point
    // to enable the ghost to start:
    if (!this.ghosting) {
      if (Math.max(
        Math.abs(this.oldPos.x - this.finger.x),
        Math.abs(this.oldPos.y - this.finger.y)
      ) >= this.START_GHOST_TOUCH_THRESHOLD) {

        this.showGhost();
      }
    } else {

      // draw stuff on the mask:
      var dist = this.distanceBetween(this.oldPos, this.finger);
      var angle = this.angleBetween(this.oldPos, this.finger);

      let x, y;
      for (let i = 0; i < dist; i += 8) {
        x = this.oldPos.x + (Math.sin(angle) * i);
        y = this.oldPos.y + (Math.cos(angle) * i);

        var radgrad = this.maskCtx.createRadialGradient(x,y,0,x,y,50);
        radgrad.addColorStop(0, 'rgba(255,255,255,0.09)');
        radgrad.addColorStop(1, 'rgba(255,255,255,0)');

        this.maskCtx.fillStyle = radgrad;
        this.maskCtx.fillRect(x-50, y-50, 100, 100);
      }

      this.maskSprite.texture.update();
      this.oldPos = { ...this.finger };

      // If we're drawing in the right area, record this edit:
      if (x >= this.gridLines.x[0]
        && x <= this.gridLines.x[this.gridLines.x.length - 1]
        && y >= this.gridLines.y[0]
        && y <= this.gridLines.y[this.gridLines.y.length - 1]) {

        this.markEdited(x, y);
      }
    }
  }

  markEdited(x,y) {
    let xQuadId = this.getDivisionId('x', x);
    let yQuadId = this.getDivisionId('y', y);
    let quadrant = ((yQuadId - 1) * (this.AREA_DIVISIONS + 1)) + xQuadId;
    this.editQuadrants[quadrant - 1]++;

    // Now check to see if we've edited all quadrants:
    let allDone = true;
    for (var i = 0; i < this.editQuadrants.length; i++) {
      if (this.editQuadrants[i] < 1) {
        allDone = false;
        break;
      }
    }

    if (allDone) this.resumeBook();
  }

  resumeBook() {
    console.log('resumeBook');
    clearTimeout(this.autoRevealTimer);
    this.complete = true;
    events.emit('setLighting', { mode: 'dark' });
    this.maskSprite.texture.update();

    // Clear canvas and bounce scroll, to indicate that scroll is again active
    var colors = { fillStyle: 'rgb(100,100,100)' };
    this.tl = new TimelineLite({
      onComplete: () => this.unlock()
    });
    this.tl.to(colors, 1, {
      colorProps: { fillStyle: 'rgb(255,255,255)' },
      onUpdate: () => {
        this.maskCtx.fillStyle = colors.fillStyle;
        this.maskCtx.rect(0,0,this.props.dimensions.width,this.props.dimensions.height);
        this.maskCtx.fill();
        this.maskSprite.texture.update();
      }
    });
  }

  storeRef(type, el) {
    if (el !== null) this[type] = el;
  }

  render() {
    return (
      <div styleName='rub-away'
        className={ClassNames('shift-ghost', this.props.order)}
        ref={h => this.storeRef('hitzoneRef', h)}>

        <div className='inner'
          ref={h => this.storeRef('floTextRef', h)}>

          {this.props.paragraphs.map((text,i) => {
            return <ReactMarkdown source={text} />
          })}
        </div>
      </div>
    )
  }

  getDivisionId(axis,val) {
    let idx = 1;
    let found = false;
    let lines = this.gridLines[axis];
    for (var i = 0; i < lines.length; i++) {
      if (val >= lines[i] === false) {
        idx = i;
        found = true;
        break;
      }
    }
    if (!found) idx = lines.length - 1;
    return idx;
  }

  distanceBetween(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
  }

  angleBetween(point1, point2) {
    return Math.atan2( point2.x - point1.x, point2.y - point1.y );
  }

}

// Apply 'react-css-modules' to this react component:
export default CSSModules(RubAway, styles);
// export default RubAway;



// WEBPACK FOOTER //
// ./app/frontend/components/panels/ghost-rub-away.jsx